export function isAnchorCompatibleWithCart(
  anchorCompatibleStyles,
  recentlyAddedCartItems
) {
  const recentlyAddedCartItemStyleId = parseInt(
    recentlyAddedCartItems.map(cartItem => cartItem.styleId)[0],
    10
  );
  return isAnchorCompatibleWithSelection(
    anchorCompatibleStyles,
    recentlyAddedCartItemStyleId
  );
}

export function isAnchorCompatibleWithSelection(
  anchorCompatibleStyles,
  selectionStyleId
) {
  return !!anchorCompatibleStyles.find(
    compatibleStyleId => compatibleStyleId === selectionStyleId
  );
}

export function isCombineEligible(
  designDirty,
  isCanvasDirty,
  anchorCompatibleStyles,
  recentlyAddedCartItems
) {
  return (
    designDirty &&
    !isCanvasDirty &&
    isAnchorCompatibleWithCart(anchorCompatibleStyles, recentlyAddedCartItems)
  );
}
